import React from 'react';

import { BasicButton } from '@adsk/alloy-react-button';
import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent } from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';
import { GetToggleButtonProps } from '../../types';

type ToggleButtonProps = StylableComponent<HTMLButtonElement> & {
  getToggleButtonProps?: GetToggleButtonProps;
  isOpen: boolean;
  disabled?: boolean;
  highlightButtonOnFocus?: boolean;
};

const ToggleButton = ({
  style,
  isOpen,
  getToggleButtonProps,
  highlightButtonOnFocus,
  as,
  ...props
}: ToggleButtonProps) => {
  const toggleButtonProps = getToggleButtonProps?.(props) || props;

  const { t } = useTranslation();
  const { tokens } = useTheme();
  const iconTokens = tokens?.component.dropdown?.control?.icon;

  return (
    <BasicButton
      data-testid={'Control__toggle'}
      aria-label={t('TOGGLE_MENU')}
      as={as}
      style={{
        padding: 0,
        height: 32,
        cursor: props.disabled ? 'not-allowed' : undefined,
        ...(highlightButtonOnFocus &&
          !isOpen && {
            '&:focus-within': {
              svg: {
                boxShadow: iconTokens?.focus?.boxShadow,
                borderRadius: iconTokens?.focus?.borderRadius,
              },
            },
          }),
      }}
      {...toggleButtonProps}
      disabled={props.disabled}
      aria-disabled={props.disabled ? true : undefined}
    >
      <ChevronDownIcon
        style={[
          {
            color: iconTokens?._?.color,
            ...(isOpen && {
              transform: 'rotate(180deg)',
            }),
          },
          style,
        ]}
      />
    </BasicButton>
  );
};

export default ToggleButton;
